import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=c53496da&"
import script from "./Errors.vue?vue&type=script&lang=ts&"
export * from "./Errors.vue?vue&type=script&lang=ts&"
import style0 from "./Errors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports